import { PostType } from "@components/severalbrands/gqlQueries";
import Image from "next/image";
import { replacePlaceholders } from "@lib/sharedUtils";
import {
    addStyleClassToIframe,
    addStyleClassToTable,
} from "@components/severalbrands/utils";
import styles from "./styles.module.scss";

export default function MainContent({ post }: { post: PostType }) {
    const category = post?.category?.label ?? post?.category?.name;
    return (
        <section className="3xl:w-[1073px] lg:w-[723px]">
            {post.image ? (
                <>
                    <div className={`relative`}>
                        <Image
                            src={post.image.fullPath}
                            alt={replacePlaceholders(post.title, {
                                category,
                            })}
                            layout="responsive"
                            objectFit="contain"
                            width={723}
                            height={480}
                        />
                    </div>
                    {post.image.caption && (
                        <div className="text-gray-500 text-sm bg-[#fffcf1] px-2 py-1">
                            {post.image.caption}
                        </div>
                    )}
                </>
            ) : (
                <div className={`relative w-full h-[480px]`}>
                    <Image
                        src={"/severalbrands/assets/images/placeHolder.png"}
                        alt={replacePlaceholders(post.title, {
                            category,
                        })}
                        layout="fill"
                        objectFit="contain"
                    />
                </div>
            )}
            <div className={styles.postContainerSeveralBrandsDomain}>
                {post.excerpt && (
                    <div
                        className=" mt-3 "
                        dangerouslySetInnerHTML={{
                            __html: replacePlaceholders(post.excerpt, {
                                category,
                            }),
                        }}
                    />
                )}

                <div
                    dangerouslySetInnerHTML={{
                        __html: addStyleClassToTable(
                            addStyleClassToIframe(
                                replacePlaceholders(post.body, {
                                    category,
                                }),
                            ),
                        ),
                    }}
                />
            </div>
            {post.tags.length > 0 && (
                <div className="lg:mt-28 mt-14 ">
                    <h3 className="3xl:text-6xl 3xl:leading-[5.5rem] lg:text-4xl text-2xl lg:leading-[4.5rem] font-semibold">
                        Tags
                    </h3>
                    <div className="flex flex-row flex-wrap gap-3 lg:mt-5 mt-3">
                        {post.tags?.map((el) => (
                            <div
                                key={el.id}
                                className={`rounded-[10px] border border-[#81818130] 3xl:px-[25px] 3xl:py-[18px] py-[14px] px-[21px] 3xl:text-2xl lg:text-lg text-base`}
                            >
                                {el.name}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
}
